import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Spin } from 'antd';
import moment from 'moment';
import { Dropdown } from 'react-bootstrap';
import { copyToClipBoard } from '../../utils';
import { renderText } from './utils';

const SMSChatMessageList = ({ messages, hasMore, loadMore, isFetchMoreLoading, messagesEndRef }) => {  

  const handleCopy = (text) => {
    copyToClipBoard(text);
  };
  // safeText removed, use renderText imported from utils

  return (
    <div
      className="nk-chat-panel"
      id="scrollableDiv"
      style={{
        height: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column-reverse',
      }}
    >
      <InfiniteScroll
         dataLength={messages.length}
         next={loadMore}
         hasMore={hasMore}
         inverse={true}
         loader={<Spin style={{ display: 'flex', margin: 'auto' }} />}
         scrollableTarget="scrollableDiv"
         style={{ display: 'flex', flexDirection: 'column-reverse' }}
      >
        {isFetchMoreLoading && <Spin style={{ margin: 'auto' }} />}
        
        {/* We need a dummy div ref at the "bottom" (which is actually top of DOM due to column-reverse?) 
            Actually column-reverse means first DOM element is at bottom of screen.
            So messages[0] should be newest.
        */}
        <div ref={messagesEndRef} /> 

        {messages.map((msg, idx) => {
            const isMe = msg.type === 'outbound'; 
            const currentMsgDate = moment(msg.createdAt);
            const nextMsg = messages[idx + 1];
            const showDateSep = !nextMsg || !currentMsgDate.isSame(moment(nextMsg.createdAt), 'day');
            
            return (
                <React.Fragment key={msg.id || idx}>
                    <div className={`chat ${isMe ? 'is-me' : 'is-you'}`}>
                        <div className="chat-content">
                            <div className="chat-bubbles">
                                <div className={`chat-bubble ${isMe ? 'align-items-start' : ''}`}>
                                    {isMe && (
                                        <div className="text-end">
                                            <Dropdown className="position-static">
                                                <Dropdown.Toggle as="a" className="btn btn-icon opacity-50">
                                                    <em className="icon ni ni-more-v" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end" size="sm">
                                                    <Dropdown.Item onClick={() => handleCopy(msg.body)}>
                                                        <em className="icon ni ni-copy me-1"/> Copy
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    )}
        
                                    <div style={{ display: "flex", flexDirection: "column", alignItems: isMe ? "flex-end" : "flex-start" }}>
                                        <div
                                            className={`chat-msg ${isMe ? "bg-primary text-white" : "bg-light"}`}
                                            style={{
                                              display: "inline-block",
                                              maxWidth: 620,
                                              padding: "10px 14px",
                                              // borderRadius: 10,
                                              wordBreak: "break-word",
                                              whiteSpace: "pre-line",
                                              // marginBottom: 8,
                                            }}
                                        >
                                            {renderText((msg.body ?? "").replace(/\\r\\n/g, "\n").replace(/\\n/g, "\n").trim())}
                                        </div>
                                    </div>

                                    {!isMe && (
                                        <div className="text-end">
                                            <Dropdown className="position-static">
                                                <Dropdown.Toggle as="a" className="btn btn-icon opacity-50">
                                                    <em className="icon ni ni-more-v" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu align="end" size="sm">
                                                    <Dropdown.Item onClick={() => handleCopy(msg.body)}>
                                                        <em className="icon ni ni-copy me-1"/> Copy
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <ul className="chat-meta">
                                <li>{moment(msg.createdAt).format('LT')}</li>
                                {/* {isMe && msg.status && <li>{String(msg.status)}</li>} */}
                            </ul>
                        </div>
                    </div>
                    {showDateSep && (
                        <div className="chat-sap">
                            <div className="chat-sap-meta">
                                <span>{currentMsgDate.format('ll')}</span>
                            </div>
                        </div>
                    )}
                </React.Fragment>
            );
        })}
      </InfiniteScroll>
    </div>
  );
};

export default SMSChatMessageList;
